import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import routes from '../../routes';
import { userIsSetSelector } from '../../selectors/userSelectors';

const EnsureAuthenticated = ({ children, preventRedirect }) => {
  const userIsSet = useSelector(userIsSetSelector);
  const history = useHistory();

  useEffect(() => {
    if (!userIsSet && !preventRedirect) {
      history.push(routes.login.path);
    }
  }, [userIsSet, history, preventRedirect]);

  return userIsSet === true ? children : null;
};

export default EnsureAuthenticated;
